import { render } from "./ProfileQuestionSubpage.vue?vue&type=template&id=0b643d7f&scoped=true"
import script from "./ProfileQuestionSubpage.vue?vue&type=script&lang=js"
export * from "./ProfileQuestionSubpage.vue?vue&type=script&lang=js"

import "./ProfileQuestionSubpage.vue?vue&type=style&index=0&id=0b643d7f&lang=css"
import "./ProfileQuestionSubpage.vue?vue&type=style&index=1&id=0b643d7f&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b643d7f"]])

export default __exports__